export default function nav() {
    structureSubmenus();
    setupHeroOverlay();
}

// Items whose admin label starts with `--` become dropdown children of the
// most recent un-prefixed item. The convention is theme-specific; document
// it so editors know to use the prefix in Ghost admin > Settings > Navigation.
function structureSubmenus() {
    const root = document.querySelector('[data-nav]');
    if (!root) return;

    const items = Array.from(root.children);
    let parent = null;
    let submenu = null;

    items.forEach((li) => {
        const raw = li.getAttribute('data-nav-label') || '';
        if (!raw.startsWith('--')) {
            parent = li;
            submenu = null;
            return;
        }

        const cleanLabel = raw.replace(/^--\s*/, '').trim();
        const link = li.querySelector('a');
        if (link) link.textContent = cleanLabel;

        if (!parent) return;

        if (!submenu) {
            submenu = document.createElement('ul');
            submenu.className = 'nav-submenu';
            parent.classList.add('nav-has-submenu');
            const parentLink = parent.querySelector('a');
            if (parentLink) {
                parentLink.setAttribute('aria-haspopup', 'true');
                parentLink.setAttribute('aria-expanded', 'false');
            }
            parent.appendChild(submenu);
        }

        li.classList.add('nav-subitem');
        submenu.appendChild(li);
    });

    root.querySelectorAll('.nav-has-submenu > a').forEach((a) => {
        a.addEventListener('click', (e) => {
            if (window.matchMedia('(hover: none), (max-width: 900px)').matches) {
                e.preventDefault();
                const expanded = a.getAttribute('aria-expanded') === 'true';
                a.setAttribute('aria-expanded', String(!expanded));
                a.parentElement.classList.toggle('nav-open');
            }
        });
    });
}

function setupHeroOverlay() {
    const head = document.getElementById('gh-head');
    const hero = document.querySelector('.hero');

    // On inner pages (no hero) we still want to make sure any stale
    // `gh-head-solid` class from a bfcache restore is cleared — sticky-cream
    // is the base state, no JS toggle needed.
    if (!head || !hero) {
        if (head) head.classList.remove('gh-head-solid');
        return;
    }

    const onScroll = () => {
        const threshold = hero.offsetHeight - head.offsetHeight - 40;
        head.classList.toggle('gh-head-solid', window.scrollY > threshold);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    // When the browser restores this page from its back/forward cache
    // (e.g. user clicks a menu link then hits Back), the scroll listener
    // is preserved but no scroll event fires — so the header can be stuck
    // in whatever class state it had when the user navigated away.
    // pageshow fires for both fresh loads AND bfcache restores; re-run
    // onScroll to resync the header to the current scroll position.
    window.addEventListener('pageshow', onScroll);
}
